import auth from '../auth';
import ApigClientFactory from '../apigClient';
import * as _ from "lodash";

export const BrandLimitService = {
    async query(roles) {
        const possibleRoles = _.intersectionBy(roles, [process.env.RTPS_ROLE_DATA_ADMIN, process.env.RTPS_ROLE_APPROVER]);
        const role = _.head(possibleRoles);
        if (!role) {
            throw new Error("User does not have access to the require role.");
        }
        const client = await this.getClient(role);
        return client.invokeApi({}, '/brandlimit', 'GET', {});
    },

    async get(brandLimitId, returnActive, roles) {
        const possibleRoles = _.intersectionBy(roles, [process.env.RTPS_ROLE_DATA_ADMIN, process.env.RTPS_ROLE_APPROVER]);
        let activePath = "";
        if (returnActive) {
            activePath = "/true";
        }
        const role = _.head(possibleRoles);
        if (!role) {
            throw new Error("User does not have access to the require role.");
        }
        const client = await this.getClient(role);
        return client.invokeApi({}, '/brandlimit/' + brandLimitId + activePath, 'GET', {});
    },

    async add(brandLimit) {
        const client = await this.getClient(process.env.RTPS_ROLE_DATA_ADMIN);
        return client.invokeApi({}, '/brandlimit', 'POST', {}, brandLimit);
    },

    async save(brandLimit) {
        const client = await this.getClient(process.env.RTPS_ROLE_DATA_ADMIN);
        return client.invokeApi({}, '/brandlimit/' + brandLimit.brand_limit_id, 'PUT', {}, brandLimit);
    },

    async requestApproval(brandLimit) {
        const client = await this.getClient(process.env.RTPS_ROLE_DATA_ADMIN);
        return client.invokeApi({}, '/brandlimit/' + brandLimit.brand_limit_id + '/request-approval', 'POST', {}, brandLimit);
    },

    async approve(brandLimit) {
        const client = await this.getClient(process.env.RTPS_ROLE_APPROVER);
        return client.invokeApi({}, '/brandlimit/' + brandLimit.brand_limit_id + '/approve', 'POST', {}, brandLimit);
    },

    async deny(brandLimit) {
        const client = await this.getClient(process.env.RTPS_ROLE_APPROVER);
        return client.invokeApi({}, '/brandlimit/' + brandLimit.brand_limit_id + '/deny', 'POST', {}, brandLimit);
    },

    async publish(brandLimit) {
        const client = await this.getClient(process.env.RTPS_ROLE_APPROVER);
        return client.invokeApi({}, '/brandlimit/' + brandLimit.brand_limit_id + '/publish', 'POST', {}, brandLimit);
    },

    async cancelUpdate(brandLimit) {
        const client = await this.getClient(process.env.RTPS_ROLE_DATA_ADMIN);
        return client.invokeApi({}, '/brandlimit/' + brandLimit.brand_limit_id + '/cancel-update', 'POST', {}, brandLimit);
    },

    async getConfig(role) {
        let config = {
            invokeUrl: process.env.RTPS_ADMIN_API_URL,
            region: process.env.AWS_REGION,
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            apiKey: undefined,
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json'
        };

        await auth.getCredentialsForRole(role)
            .then((credentials) => {
                config.accessKey = credentials.Credentials.AccessKeyId;
                config.secretKey = credentials.Credentials.SecretKey;
                config.sessionToken = credentials.Credentials.SessionToken;
            });
        return config;
    },

    async getClient(role) {
        const config = await this.getConfig(role);
        return ApigClientFactory.newClient(config);
    }
};



// WEBPACK FOOTER //
// ./src/services/rtps/brand-limit.service.js